import { useState, useEffect } from "react";

function WhatsAppButton() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const phoneNumber = "919045597604";
  const message = "Hello, I want legal consultation";
  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  // Listen for chatbot state changes
  useEffect(() => {
    const handleChatbotState = (event) => {
      setIsChatbotOpen(event.detail.isOpen);
    };

    window.addEventListener('chatbotStateChange', handleChatbotState);
    return () => window.removeEventListener('chatbotStateChange', handleChatbotState);
  }, []);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="!fixed bottom-6 right-6 z-[9999] bg-[#25D366] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:scale-110 hover:shadow-xl transition-all duration-300"
      style={{
        opacity: isChatbotOpen ? 0.3 : 1,
        pointerEvents: isChatbotOpen ? "none" : "auto",
        transition: "all 0.3s ease"
      }}
    >
      <div className="bg-[#25D366] hover:bg-[#1ebe5d] text-white w-14 h-14 flex items-center justify-center rounded-full shadow-lg transition transform hover:scale-110">
        {/* WhatsApp Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="white"
          className="w-7 h-7"
        >
          <path d="M16 .5C7.5.5.5 7.5.5 16c0 2.8.7 5.5 2.1 7.9L.5 31.5l7.8-2.1c2.3 1.2 4.9 1.9 7.7 1.9 8.5 0 15.5-7 15.5-15.5S24.5.5 16 .5zm0 28.3c-2.4 0-4.8-.6-6.9-1.8l-.5-.3-4.6 1.2 1.2-4.5-.3-.5C3.6 20.7 3 18.4 3 16 3 9.4 9.4 3 16 3s13 6.4 13 13-6.4 12.8-13 12.8zm7.1-9.6c-.4-.2-2.4-1.2-2.7-1.3-.4-.1-.6-.2-.9.2-.3.4-1 1.3-1.2 1.6-.2.2-.4.3-.8.1-.4-.2-1.7-.6-3.2-2-1.2-1.1-2-2.4-2.3-2.8-.2-.4 0-.6.2-.8.2-.2.4-.4.6-.6.2-.2.3-.4.4-.6.1-.2 0-.5 0-.7 0-.2-.9-2.2-1.2-3-.3-.7-.6-.6-.9-.6h-.7c-.2 0-.6.1-.9.4-.3.4-1.2 1.2-1.2 3 0 1.7 1.3 3.4 1.5 3.6.2.2 2.6 4 6.3 5.4.9.3 1.5.5 2 .6.8.1 1.5.1 2.1.1.6 0 2-.8 2.3-1.6.3-.8.3-1.5.2-1.6-.1-.2-.3-.3-.7-.5z" />
        </svg>
      </div>
    </a>
  );
}

export default WhatsAppButton;